import { Component, OnInit } from "@angular/core";
import { BookServiceService } from "../services/book-service.service";

@Component({
  selector: "app-favorite-books",
  templateUrl: "./favorite-books.component.html",
  styleUrls: ["./favorite-books.component.scss"]
})
export class FavoriteBooksComponent implements OnInit {
  constructor(private Book: BookServiceService) {}
  title = " Top Rated books";

  favBooks;

  ngOnInit() {
    this.Book.allBooks().subscribe(data => {
        this.favBooks= data.map(el => {
          return {
            id: el.payload.doc.id,
            ...el.payload.doc.data()
          };
        }).sort(function(a: any, b: any) {
          return b.rate - a.rate;
        })
        

    });
  }
}
